import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { City } from '../../types';

export interface AllCitiesListRequestParams {
  CountryCode: string;
  StateCode: string;
}

// TODO: remove, because we have cities in the entities module
export const getAllCitiesListAPI = (params: AllCitiesListRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.PRIMARY}/GetCities`,
  });
};

export type AllCitiesResponse = City[];

export const fetchAllCitiesList = async (params: AllCitiesListRequestParams): Promise<AllCitiesResponse> => {
  const response: AxiosResponse<AllCitiesResponse> = await getAllCitiesListAPI(params);
  return response.data;
};
